import React from "react";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

interface Props {
  text?: string;
  my?: number;
}

const ComponentDivider: React.FC<Props> = ({ text = "Or", my = 4 }) => {
  return (
    <Box my={my}>
      <Divider
        sx={{
          fontWeight: 500,
          fontSize: 14,
          color: "text.secondary",
          "&::before, &::after": {
            borderTop: "1px solid #ddd",
          },
        }}
      >
        {text}
      </Divider>
    </Box>
  );
};

export default ComponentDivider;
